import { render, staticRenderFns } from "./warehouseStatement.vue?vue&type=template&id=25f4ec26&scoped=true"
import script from "./warehouseStatement.vue?vue&type=script&lang=js"
export * from "./warehouseStatement.vue?vue&type=script&lang=js"
import style0 from "./warehouseStatement.vue?vue&type=style&index=0&id=25f4ec26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4ec26",
  null
  
)

export default component.exports